import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "Type marchand", -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, "Nom", -1)
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, "Prénom", -1)
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, "Raison sociale", -1)
const _hoisted_20 = { key: 4 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, "Adresse résidence", -1)
const _hoisted_22 = { key: 5 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "Adresse boutique", -1)
const _hoisted_24 = { key: 6 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "Email", -1)
const _hoisted_26 = { key: 7 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, "Téléphone", -1)
const _hoisted_28 = { key: 8 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, "Secteur d'activité", -1)
const _hoisted_30 = { key: 9 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, "Ifu", -1)
const _hoisted_32 = { key: 10 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, "Rccm", -1)
const _hoisted_34 = { key: 11 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, "Statut", -1)
const _hoisted_36 = { key: 12 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, "Code marchand", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/liste-marchands",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                _createTextVNode("Retour")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tbody", null, [
              (_ctx.marchand?.typeMarchand)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _hoisted_11,
                    (_ctx.marchand?.typeMarchand == 1)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_12, "Personne Physique"))
                      : _createCommentVNode("", true),
                    (_ctx.marchand?.typeMarchand == 2)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_13, "Personne Morale"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.nom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.prenom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.prenom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.raisonSocial)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.raisonSocial), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.adresseResidence)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.adresseResidence), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.adresseBoutique)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.adresseBoutique), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.email)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.email), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.telephone)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.telephone), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.secteurActivite)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.secteurActivite.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.ifu)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.ifu), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.rccm)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.rccm), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.statut)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.statut), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.marchand?.codeMarchand)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("td", null, _toDisplayString(_ctx.marchand?.codeMarchand), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}